<!-- CC: extracted from integrations.component.html -> Exchange popup section -->
<div class="flex-column f-1-0 overflow-auto gap-4" *ngIf="planInfo">

	<!--Connect section-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;" [ngClass]="isConnected() ? 'text-success' : 'text-warning'">{{isConnected() ? 'Connected' : 'Disconnected'}}</span>
			<span style="font-size: 12px; max-width: 300px;">{{isConnected() ? 'Your mail server is now integrated with ' + gs.corpname : 'Allow us to establish a secure connection to your Exchange Server using admin-credentials.'}}</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;"
				   endIcon="far fa-plug"
				   [loading]="integrationActionInProcess"
				   (action)="connectToExchange();">
				{{isConnected() ? 'Disconnect' : 'Connect'}}
			</btn-c>
		</div>
	</div>

	<!--Advanced Permissions-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Advanced Permissions</span>
			<span style="font-size: 12px; max-width: 300px;">{{dic.MESSAGES.advancedPermissionsInfo}}</span>
		</div>
		<div class="w-50">
			<btn-c style="width: 135px;" endIcon="far fa-plug" *ngIf="!planInfo.exchange_server.advanced_enabled"
				   [isDisabled]="integrationActionInProcess || !isConnected()"
				   [loading]="integrationActionInProcess"
				   (action)="connectToExchangeAdvanced();">
				Grant Advanced Permissions
			</btn-c>

			<div class="flex-column gap-2" *ngIf="planInfo.exchange_server.advanced_enabled">
				<span style="color: green;">Granted</span>
				<btn-c style="width: 135px;" endIcon="far fa-redo"
					   [isDisabled]="integrationActionInProcess || !isConnected()"
					   [loading]="integrationActionInProcess"
					   (action)="connectToExchangeAdvanced();">
					Update Permissions
				</btn-c>
			</div>
		</div>
	</div>

	<!--Troubleshoot-->
	<div class="flex-column gap-3">
		<div class="flex-row gap-4">
			<div class="w-50 flex-column gap-2">
				<span style="font-weight: 500;">Troubleshoot</span>
				<span style="font-size: 12px; max-width: 300px;">Checks that the Microsoft Graph API connection and its permissions work for your tenant and a sample mailbox</span>
			</div>
			<div class="w-50">
				<btn-c style="width: 135px;" endIcon="far fa-stethoscope"
					   [loading]="graphCheckInProcess"
					   [isDisabled]="graphCheckInProcess || !isConnected()"
					   (action)="troubleshootGraphAccess();">
					Run Checks
				</btn-c>
			</div>
		</div>

		<div class="flex-column gap-2" *ngIf="graphChecks">
			<span style="font-size: 12px;">{{graphCheckCount('ok')}} passed, {{graphCheckCount('warning')}} warning, {{graphCheckCount('failed')}} failed</span>
			<div style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px;">
				<div class="flex-row justify-content-between align-items-center gap-3 px-3 py-2 border border-1 rounded-2" *ngFor="let check of graphChecks">
					<div class="flex-column" style="min-width: 0;">
						<span class="text-truncate" style="font-size: 12px;" [tooltip]="check.description" placement="top">{{check.check}} <i class="far fa-info-circle"></i></span>
						<span *ngIf="check.status !== 'ok' && check.message" class="text-muted" style="font-size: 11px;">{{check.message}}</span>
					</div>
					<span class="px-3 py-1 border rounded-2 text-center" style="font-size: 12px; min-width: 80px; white-space: nowrap;"
						  [ngClass]="check.status === 'ok' ? 'border-success bg-success text-white' : (check.status === 'warning' ? 'border-warning bg-warning text-white' : 'border-danger bg-danger text-white')">
						{{check.status === 'ok' ? 'Passed' : (check.status === 'warning' ? 'Warning' : 'Failed')}}
					</span>
				</div>
			</div>
		</div>
	</div>

	<!--Cloud API endpoint-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Cloud API endpoint</span>
			<span style="font-size: 12px; max-width: 300px;">Exchange and Collaboration share this Microsoft cloud and app registration.</span>
		</div>
		<div class="w-50">
			<app-dropdown-c style="width: 210px; --bs-dropdown-max-height: 180px; --bs-dropdown-overflow: auto; display: block;" [text]="selectedServerEndpoint.name">
				<li *ngFor="let entry of dic.CONSTANTS.exchangeServerEndpoints | keyvalue"
					(click)="changeEndpoint(entry.value)">
					{{ entry.value.name }}
				</li>
			</app-dropdown-c>
		</div>
	</div>

	<p class="text-warning" role="note" *ngIf="selectedServerEndpoint.name === dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name">Processing GCC High data on Trustifi infrastructure may conflict with your FedRAMP or ITAR requirements. Confirm suitability with your compliance team before connecting.</p>

	<!--Domains-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Domains</span>
			<span style="font-size: 12px; max-width: 300px;">Domains managed by your Exchange server</span>
		</div>
		<div class="w-50">
			<div *ngFor="let domain of planInfo.exchange_server.verified_domains">
				- {{domain}}
			</div>
			<span class="text-muted flex-row align-items-center h-100" *ngIf="!planInfo.exchange_server.verified_domains?.length">No verified domains</span>
		</div>
	</div>

	<!--Groups/Aliases-->
	<div class="flex-row gap-4">
		<div class="w-50 flex-column gap-2">
			<span style="font-weight: 500;">Groups/Aliases</span>
			<span style="font-size: 12px; max-width: 300px;">Knowing your groups/aliases will allow us to protect you better</span>
		</div>
		<div class="w-50 flxRow" style="flex-wrap: wrap; align-items: flex-start;">
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   endIcon="far fa-users"
				   (action)="getGroups(true);">
				Show Groups
			</btn-c>
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   endIcon="far fa-users"
				   (action)="getMailboxesAliases(true);">
				Show Aliases
			</btn-c>
			<btn-c style="width: 135px; margin: 0 5px 7px 0;"
				   [loading]="integrationActionInProcess"
				   endIcon="{{integImportGroupsSummary ? 'far fa-sync': 'far fa-users-cog'}}"
				   [isDisabled]="!isConnected() || integrationActionInProcess"
				   (action)="integImportGroups();">
				Sync
			</btn-c>
		</div>
	</div>

	<!--Guide link-->
	<div class="guide-link-wrapper flxRow hSpace05" style="align-self: flex-end; font-weight: 500;">
		<span>Full guide:</span>
		<a class="a-link" [href]="dic.CONSTANTS.trustifiDefault.resources.docsGeneral + '/microsoft-exchange-office365'" target="_blank">Exchange integration</a>
	</div>
</div>

<!--Change endpoint popup-->
<popup-c class="bs-enabled" *ngIf="changeEndPointPopup?.show"
		 head="Change cloud API endpoint" size="dynamic"
		 (closeCb)="changeEndPointPopup.show = false;"
	(confirmCb)="changeEndPointPopup.endpoint ? saveSovereignCloud() : changeEndPointPopup?.doneCb()"
	[buttons]="{cancel: 'Cancel', confirm: {text: 'Change', disabled: changeEndPointPopup.applyInProcess || integrationActionInProcess}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<div class="d-flex gap-1 text-danger pt-2" style="font-size: 14px;">
			<i class="zmdi zmdi-alert-circle-o" style="font-size: 1.5rem; margin-top: -6px;"></i>
			{{changeEndPointPopup.subTitle}}
		</div>

		<p class="text-warning" role="note" *ngIf="changeEndPointPopup.endpoint?.name === dic.CONSTANTS.exchangeServerEndpoints.USGovernmentGCCHigh.name">Processing GCC High data on Trustifi infrastructure may conflict with your FedRAMP or ITAR requirements. Confirm suitability with your compliance team before connecting.</p>

		<ul>
			<li>Make sure you have selected the correct endpoint. Selecting an incorrect endpoint can cause communication failures with the cloud API.</li>
			<li *ngIf="changeEndPointPopup.endpoint">Create one app with all required permissions. Its client ID and secret are shared by Exchange, EXO Admin and Collaboration. Disconnect all three before changing the cloud or app. The tenant is detected during consent.</li>
		</ul>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.endpoint">
			<div style="min-width: 120px;">Client ID</div>
			<input type="text" placeholder="Client ID" style="width:330px;" [required]="true" [(ngModel)]="changeEndPointPopup.clientIdInput"/>
		</div>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.endpoint">
			<div style="min-width: 120px;">Client secret</div>
			<input type="password" placeholder="Client secret" style="width:330px;" [required]="!changeEndPointPopup.clientSecretSet" [(ngModel)]="changeEndPointPopup.clientSecretInput"/>
		</div>
		<span *ngIf="changeEndPointPopup.endpoint && changeEndPointPopup.clientSecretSet" style="font-size: 12px;">Leave a secret blank only when keeping the same cloud and client ID.</span>

		<!--will show only when selecting exchangeServerEndpoints.Hybrid-->
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.azureADInput !== undefined">
			<div style="min-width: 120px;">Azure AD</div>
			<input type="text" placeholder="Azure AD endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.azureADInput"/>
		</div>
		<div class="align-items-center flex-row gap-3" *ngIf="changeEndPointPopup.microsoftGraphAPIInput !== undefined">
			<div style="min-width: 120px;">Microsoft Graph API</div>
			<input type="text" placeholder="Microsoft Graph API endpoint"
				   style="width:330px;" [required]="true"
				   [(ngModel)]="changeEndPointPopup.microsoftGraphAPIInput"/>
		</div>
	</div>
</popup-c>


<groups-popup-c
	*ngIf="showGroups"
	(cancelCb)="showGroups = false"
	[showActions]="true"
	[popupTitle]="'Groups'">
</groups-popup-c>

<aliases-popup-c *ngIf="showAliases"
                 (cancelCb)="getMailboxesAliases(false)"
                 [popupTitle]="'Mailboxes Aliases'"
                 [showActions]="true">
</aliases-popup-c>
